import { Number3, TransformControlsMode } from '@fabric-web/3d-viewer';

export const UNDO_MAX_HISTORY_SIZE = 50;
export const UNDO_COMBINE_CHANGES_INTERVAL_MSEC = 100;

const SCANS_POSITION_PRECISION = 3;
const SCANS_ROTATION_PRECISION = 12;

export const SCANS_POSITION_PRECISION_FACTOR = 10 ** SCANS_POSITION_PRECISION;
export const SCANS_ROTATION_PRECISION_FACTOR = 10 ** SCANS_ROTATION_PRECISION;

export const AXES = ['X', 'Y', 'Z'];
export const XYZ_LABELS = AXES;
export const ROLL_PITCH_YAW_LABELS = ['Roll', 'Pitch', 'Yaw'];

export const AXES_NAMES = {
  translate: AXES,
  rotate: ROLL_PITCH_YAW_LABELS,
  scale: AXES,
};

export const ALL_ZEROS: Number3 = [0, 0, 0];
export const ALL_ONES: Number3 = [1, 1, 1];

export const ALL_TRANSFORM_MODES = [
  TransformControlsMode.Translate,
  TransformControlsMode.Rotate,
  TransformControlsMode.Scale,
];

export const ALLOWED_TRANSFORM_MODES = [
  TransformControlsMode.Translate,
  TransformControlsMode.Rotate,
];
